import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { format } from 'date-fns';
import { Cell, ActionCell } from 'components/Table';
import {Table, Thead, Th, Tr, Td} from 'reactable';
import GraduationIcon from 'assets/icons/graduation-cap';
import { keyedObjToArr } from '../util';

import 'sass/components/table.scss';

export class StatusCell extends Component {
	render () {
		//TODO get active or disabled for the classroom
		return(
			<Cell className={this.props.className} >
				<div className="avatar teacher"><InlineSVG src={GraduationIcon} element="span" className="icon" /></div>
			</Cell>);
	}
}

export class CustomActionCell extends Component {
	render () {
		let canEdit = this.props.profile.role === 'admin' || this.props.profile.id === this.props.item.teacher;
		let canDelete = this.props.profile.role === 'admin';
		return (
			<ActionCell
				className="align-center"
				edit={ canEdit ? this.props.editClassroom : null}
				delete={ canDelete ? this.props.deleteClassroom : null}
				{...this.props}
			/>
		);
	}
}

const getFormattedDate = (timestamp) => {
	if (timestamp) {
		return format(new Date(timestamp*1000), 'MM/DD/YYYY');
	}
	return '';
};

export default class ClassroomList extends Component {

	render () {
		let defaultSort = 'name';
		if (this.props.profile.role === 'admin')
			defaultSort = 'school';

		return (
			<Table
				className="table ui-list"
				sortable={['name','school','expiration','product','students']}
				filterable={['name','school','product']}
				hideFilterInput
				noDataText=" No classrooms found"
				defaultSort={defaultSort}
			>
				<Thead className="list-row header">
					<Th className="list-cell avatar-cell" column="status">&nbsp;</Th>
					<Th className="list-cell" column="name">Name</Th>
					<Th className="list-cell" column="school" >School</Th>
					<Th className="list-cell" column="product">Product</Th>
					<Th className="list-cell narrow" column="students">Students</Th>
					<Th className="list-cell" column="expiration">License Expiration Date</Th>
					<Th className="list-cell align-center" column="edit">Edit</Th>
				</Thead>
				{this.props.classrooms.map((classroomItem, index) => {
					const school = this.props.schools[classroomItem.school];

                    let products = [];
                    let orderIds = this.props.orders ? Object.keys(this.props.orders) : [];

                    orderIds.forEach( (orderId)=> {
						const orderProducts = keyedObjToArr(this.props.orders[orderId].products);
						const orderExpiration = getFormattedDate(this.props.orders[orderId].endDate);
						orderProducts.forEach( product => product.expiration = orderExpiration );
                        products = products.concat(orderProducts);
                    });

                    let product = products.find( (productItem) => {
                        return productItem.productId === classroomItem.product;
					});
					return (
						<Tr className="list-row" key={index}>
							<Td className="avatar-cell" column="status">
								<StatusCell
									item={classroomItem}
								/>
							</Td>
							<Td className="list-cell" column="name" data={classroomItem.name}>
								{classroomItem.name}
							</Td>
							<Td className="list-cell" column="school">
								{school ? school.name : ''}
							</Td>
							<Td className="list-cell" column="product">
								{product ? product.name : ''}
							</Td>
							<Td className="list-cell narrow" column="students">
								{classroomItem.studentCount}
							</Td>
							<Td className="list-cell" column="expiration">
								{product ? product.expiration : ''}
							</Td>
							<Td className="list-cell align-center" column="edit">
								<CustomActionCell
									item={classroomItem}
									profile={this.props.profile}
									editClassroom={this.props.editClassroom}
									deleteClassroom={this.props.deleteClassroom}
								/>
							</Td>
						</Tr>
					);
				}, this)}
			</Table>
		);
	}

}






// WEBPACK FOOTER //
// ./js/components/ClassroomList.js